import { ActionIcon, Group } from '@mantine/core';
import type { ReactNode } from 'react';
import { Icon } from './navIcons';

/**
 * Zeilenaktionen in Tabellen (Faruq 2026-08-24: „Werkbank sollte wie aus einem
 * Guss aussehen").
 *
 * Vorher trug jede Tabelle beschriftete Knöpfe — „Bearbeiten Löschen" —, die
 * je nach Seite in unterschiedlicher Reihenfolge, Größe und Ausrichtung
 * standen und in einer dichten Liste mehr Platz brauchten als die Daten. Jetzt
 * überall dasselbe: Symbole, rechtsbündig, Stift vor Kreuz, das Kreuz in Rot.
 *
 * Jedes Symbol trägt `aria-label` UND `title` — ohne Beschriftung ist der
 * Name die einzige Erklärung, für die Vorlesehilfe wie für die Maus.
 */
export function RowActionGroup({ children }: { children: ReactNode }) {
  return (
    <Group gap={2} wrap="nowrap" justify="flex-end">
      {children}
    </Group>
  );
}

/** Stift-Symbol; öffnet den Bearbeiten-Dialog der Zeile. */
export function EditIconButton({
  title,
  onClick,
  testId,
  disabled,
}: {
  /** Was genau bearbeitet wird — „Gebäude bearbeiten", nicht nur „Bearbeiten". */
  title: string;
  onClick: () => void;
  testId?: string;
  disabled?: boolean;
}) {
  return (
    <ActionIcon
      variant="subtle"
      color="gray"
      size="md"
      aria-label={title}
      title={title}
      disabled={disabled}
      onClick={onClick}
      data-testid={testId}
    >
      <Icon name="edit" size={17} />
    </ActionIcon>
  );
}
